/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { RootStore } from 'src/core/stores/RootStore';
import { QnaMakerLanguageSettings } from 'src/qnaMaker/verticals/qnaMakerProjectCreationModal/QnaMakerProjectCreationModal';

export const getCreationLanguageResourceSettings = (rootStore: RootStore): QnaMakerLanguageSettings => {
    if (rootStore.qnaProjectStoreHouse.items.length === 0) {
        return { setting: 'unset' };
    }
    if (rootStore.qnaProjectStoreHouse.items[0].multilingualResource) {
        return { setting: 'multiLingual' };
    }
    return { setting: 'singleLanguage', language: rootStore.qnaProjectStoreHouse.items[0].language };
};
